import { isFailedActivityJobStatus } from './job';
import type { ActivityItem } from './models';

export function hasNewActivityFailure(
    previous: ActivityItem | null,
    next: ActivityItem
): boolean {
    return next.jobs.some((job) => {
        if (!isFailedActivityJobStatus(job.status)) return false;

        const previousJob = previous?.jobs.find(
            (candidate) => candidate.jobId === job.jobId
        );
        return previousJob?.status !== job.status;
    });
}

export function hasNewActivityWarning(
    previous: ActivityItem | null,
    next: ActivityItem
): boolean {
    return next.jobs.some((job) => {
        if (!job.warning || job.status !== 'Completed') return false;

        const previousJob = previous?.jobs.find(
            (candidate) => candidate.jobId === job.jobId
        );
        return previousJob?.warning !== true;
    });
}
